import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import stockLocationKeys from '@/api/queries/stockLocations/keyFactory';
import { graphql } from '@/gql';
import { ArchiveStockLocationMutation as TArchiveStockLocationMutation } from '@/gql/graphql';

const ArchiveStockLocationMutation = graphql(`
  mutation ArchiveStockLocation($id: ID!) {
    archiveStockLocation(id: $id) {
      id
      archivedAt
    }
  }
`);

const useArchiveStockLocation = (
  options?: UseMutationOptions<TArchiveStockLocationMutation, unknown, string>
) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};

  return useMutation({
    mutationFn: (id) => gqlClient.request(ArchiveStockLocationMutation, { id }),
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries({ queryKey: stockLocationKeys.all });
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useArchiveStockLocation;
